

import moment from "moment";
import { addLocale } from 'primereact/api';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { MultiSelect } from 'primereact/multiselect';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from "react";
import 'react-slideshow-image/dist/styles.css';
import ReactToPrint from 'react-to-print';
import count_days from "../functions/count_days";
import sum_amount from "../functions/sum_total_amount";
import sum_amount_by_payment_type from "../functions/sum_total_amount_by_payment_type";
import view_apartment_type_ar from "../functions/view_apartment_type";
import { _endPoints, getallusers, getapartments, getpaymentsdate } from "../Helper/links";
import API from "../Helper/server/API";
import { InvoiceContext } from '../bookings/invoice/Invoice_Context';
import InvoicePaymentsDay from "../bookings/payments/views/invoices/invoice_payments_day";
import empty from '../public/svg/empty.svg';
import InvoiceUsersTracking from "./invoice_usersTracking";

function UsersTracking()
{
    const toast = useRef(null);
    const componentRef = useRef();
    const buttonRef = useRef();
    const [isShown, setIsShown] = useState(false);
    const items = Array.from({ length: 10 }, (v, i) => i);
    addLocale('ar', {
        firstDayOfWeek: 6,
        dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        dayNamesMin: ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
        monthNames: ['January-01', 'February-02', 'March-03', 'April-04', 'May-05', 'June-06', 'July-07', 'August-08', 'September-09', 'October-10', 'November-11', 'December-12']    ,
        monthNamesShort: ['Jan-01', 'Feb-02', 'Mar-03', 'Apr-04', 'May-05', 'Jun-06', 'Jul-07', 'Aug-08', 'Sep-09', 'Oct-10', 'Nov-11', 'Dec-12'],
        today: 'اليوم',
        clear: 'تفريغ',
      });
    //____________________________________________________________
    const[loading1 , set_loading1] = useState(false);
    const [user_tracking, set_user_tracking] = useState([]);
    //____________________________________________________________
    const [date, setDate] = useState(new Date());
    const [PrintUser_tracking, setPrintUser_tracking] = useState(false);
    //_______________________________________________________________________________________
    //                      Get Reservationes
    const [users, set_users] = useState([]);
    const [users_view, set_users_view] = useState([]);
    const[loading_users , set_loading_users] = useState(false);
    const UsersViewItemTemplate = (user) => {
        return (
            <div className="flex align-items-center gap-1" style={{fontFamily:"Cairo",direction:"rtl",paddingRight:".5rem"}} >
                <span>{user.name}</span>
            </div>
        );
    };
    const GetUsers = async () =>
    {
        set_loading_users(true);
        const response = await API.get(getallusers)
        if(response?.success===1)
        {
            set_users(response.users);
        }
        set_loading_users(false);
    }
    const GetUserTracking = async () =>
    {
        set_loading1(true);
        var users = [];
        // eslint-disable-next-line array-callback-return
        users_view.map(item=>{
            if(item.ID_user){
                users.push(item.ID_user);
            }
        })

        var data = {
            date : moment(date).format("yyyy-MM-DD"),
            users_selected:users,
        }
        const response = await API.post(_endPoints.users.get_user_tracking,data);
        if(response?.success===1)
        {
            set_user_tracking(response?.data);
        }
        else if(response?.success===0)
        {
            toast?.current?.show({
                style:{
                    fontFamily:"Cairo",
                    fontSize:"1.2rem"
                },
                life: 5000,
                severity:'error', summary: 'خطــاء', detail: response.msg
            });
        }
        set_loading1(false);
    }

    //____________________________________________________________
    const handel_Day = (e) =>{
        setDate(e.target.value);
    };
    const View_Date = (data)=>{
        return (
            <strong >
                {moment(data.date).format('yyyy-MM-DD')}
                <br></br>
                {moment(data.date).format('hh:mm A')}
            </strong>
        )
    }
    const footerDay = <>
                <table className="table table-bordered table-striped no-margin table-invoice" style={{fontSize:"17px"}}>
                        <thead className="color-view bg- ">
                            <tr >
                                <th style={{fontSize:"17px"}}>إجمالي  الحــركات </th>
                            </tr>
                            <tr >
                                <td >{user_tracking.length}</td>
                            </tr>

                        </thead>
                </table>
                <div className="col-md-12" dir="ltr">
                    <Button dir='ltr' type="button"  label=" عــرض "  icon='fa fa-file'  outlined
                    onClick={e=>setPrintUser_tracking(true)}
                    />
                </div>
            </>
     useEffect(()  =>
    {
        GetUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const scrollStyle = {
        overflowY: "auto",
        scrollbarWidth: "thin", // للمتصفحات غير Chrome

    };
    const scrollBarCSS = `
    ::-webkit-scrollbar {
            display: block !important;
            width: 5px;
            height: 8px;
        }
    `;
    return (
    <div className="page-wrapper" dir="rtl" >
        <div className="content-wrapper">
            <Toast ref={toast} position="top-center" style={{margin:"0 1rem 0 0 !important",fontFamily:"Cairo"}} remove />

            <div className="page-heading">
                <h1 className="page-title"> متــابعة المستخــدمين </h1>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a href="index.html"><i className="la la-home font-20"></i></a>
                    </li>
                </ol>
            </div>
            <div className="card p-3">
                <div className="col-md-12" style={{fontFamily:"Cairo"}}>
                    <div className="row">
                        <div className="col-md-3">
                            <label id="lday"> تـــاريخ </label>
                            <Calendar value={date}
                            className="col-md-12"
                            showButtonBar
                            onChange={(e) => handel_Day(e)}
                            maxDate={new Date()}
                            dateFormat="yy-mm-dd"
                            style={{padding:"0",fontFamily:"Cairo"}}
                            panelStyle={{fontFamily:"Cairo"}}
                            locale="ar"
                            />
                        </div>
                        <div className="col-md-3">
                            <label id="lday">المستخــدمين</label>
                            <MultiSelect className="col-md-12"
                                options={users}
                                value={users_view}
                                itemTemplate={UsersViewItemTemplate}
                                onChange={(e) => set_users_view(e.target.value)}
                                optionLabel="name"
                                display="chip"
                                placeholder="اختار المستخدمين"
                                emptyMessage={<p style={{fontFamily:"Cairo",textAlign:"center"}}>لا توجد خيارات متاحة</p>}
                                maxSelectedLabels={3}
                                style={{fontFamily:"Cairo",fontSize:"15px",width:"100%"}}
                                loading={loading_users}
                            />
                        </div>
                        <div className="col-md-1" >
                            <Button
                                dir='ltr'
                                type="button"
                                icon="pi pi-search"
                                label="عرض"
                                outlined
                                onClick={GetUserTracking}
                                loading={loading1}
                                disabled={loading_users || loading1 ? true:false}
                                style={{fontFamily:"Cairo",marginTop:"30PX",display:"inline"}}
                            />
                        </div>
                    </div>
                </div>
                <br></br>
                <style>{scrollBarCSS}</style>
                {
                loading1?
                <DataTable value={items} className="p-datatable-striped"tableStyle={{ minWidth: '50rem' }} style={{fontFamily:"Cairo",direction:"rtl"}}>
                        <Column field="date" header="تاريخ والوقت" sortable style={{width: '15%',textAlign:"right" }} body={<Skeleton />}></Column>
                        <Column field="name" header="المستخدم"  style={{ textAlign:"right" }}  body={<Skeleton />}></Column>
                        <Column field="username" header="البريد الإلكتروني"  style={{ textAlign:"right" }}  body={<Skeleton />}></Column>
                        <Column field="table_name" header="الحركة"  style={{ textAlign:"right" }}  body={<Skeleton />}></Column>
                        <Column field="details_tracking" header="تفاصيل الحركة"  style={{ width: '30%',textAlign:"right" }}  body={<Skeleton />}></Column>
                </DataTable>
                :
                <DataTable value={user_tracking} loading={loading1}
                    dataKey="ID_tracking"
                    metaKeySelection={false} dragSelection
                    stripedRows
                    footer={footerDay}
                    scrollable scrollHeight="600px"
                    emptyMessage={<center><img src={empty} alt="empty" width={"10%"} className='m-4'></img><h3>لايــوجد حــركات</h3></center>}
                    tableStyle={scrollStyle}
                    style={{fontFamily:"Cairo",direction:"rtl"}}
                >
                        <Column field="date" header="تاريخ والوقت" body={View_Date} sortable style={{width: '15%',textAlign:"right" }}></Column>
                        <Column field="name" header="المستخدم"  style={{ textAlign:"right" }}></Column>
                        <Column field="username" header="البريد الإلكتروني"  style={{ textAlign:"right" }}></Column>
                        <Column field="table_name" header="الحركة"  style={{ textAlign:"right" }}></Column>
                        <Column field="details_tracking" header="تفاصيل الحركة"  style={{ width: '30%',textAlign:"right" }}></Column>
                    </DataTable>
                }
            </div>
            {
                PrintUser_tracking ?
                (
                    <>
                        <Dialog  dir="rtl" header="مدفوعات اليومية"  visible={PrintUser_tracking} maximizable style={{ width: '50vw',fontFamily:"Cairo" }}
                        onHide={() =>setPrintUser_tracking(false)}  maximized={window.innerWidth <= 1230 ?true:false}
                        footer={
                            <div className="text-center">
                            <ReactToPrint
                                trigger={
                                    () =>  <Button dir='ltr' type="button"  label=" طبــاعة "  icon='fa fa-print'  outlined
                                    ref={buttonRef}  onClick={(e)=> setIsShown(current => !current)}
                                    />
                                }
                                content={() => componentRef.current}
                                maximized={true}
                            />
                        </div>
                        }
                        >
                            <InvoiceContext.Provider value={user_tracking}   >
                            {PrintUser_tracking &&  <div ref={componentRef}>  <InvoiceUsersTracking  ></InvoiceUsersTracking></div>}
                            </InvoiceContext.Provider>
                        </Dialog>
                    </>
                )
                :
                (null)
            }
        </div>
    </div>
    )
}

export default UsersTracking


